import { useEffect, useState } from 'react';
import type { League } from '../api';
import { loadLeagues } from '../sport';

/** Kies welke competities de logo-widget toont, gegroepeerd per sport. Volgorde = volgorde van aanklikken. */
export function LeaguePicker({ value, onChange }: { value?: string[]; onChange: (ids: string[]) => void }) {
  const [leagues, setLeagues] = useState<League[] | null>(null);
  useEffect(() => {
    loadLeagues().then(setLeagues).catch(() => setLeagues([]));
  }, []);
  if (!leagues) return <p className="subtle">Competities laden…</p>;

  const chosen = value?.length ? value : leagues.filter((l) => l.default).map((l) => l.id);
  const toggle = (id: string) => onChange(chosen.includes(id) ? chosen.filter((x) => x !== id) : [...chosen, id]);
  const sports = [...new Map(leagues.map((l) => [l.sport, l.sportName])).entries()];

  return (
    <div className="ed-field">
      <span>Competities ({chosen.length})</span>
      {sports.map(([sport, name]) => (
        <div key={sport} className="league-pick-group">
          <span className="subtle">{name}</span>
          <div className="chip-wrap">
            {leagues.filter((l) => l.sport === sport).map((l) => (
              <button key={l.id} className="chip league-chip" aria-pressed={chosen.includes(l.id)} onClick={() => toggle(l.id)}>
                {(l.badge ?? l.logo) && <img src={(l.badge ?? l.logo)!} alt="" referrerPolicy="no-referrer" />}
                {l.name}
              </button>
            ))}
          </div>
        </div>
      ))}
      <div className="row" style={{ gap: 8 }}>
        <button className="btn btn-sm" onClick={() => onChange(leagues.filter((l) => l.default).map((l) => l.id))}>Standaardkeuze</button>
      </div>
      <span className="subtle hint">Op Home staat wat nu live is vooraan, daarna vandaag, daarna later deze week. Logo's komen van TheSportsDB.</span>
    </div>
  );
}
